export default __webpack_public_path__ + "static/media/verizon-logo.cf986b39.svg";